"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SCENE_ASPECT_RATIO", {
  enumerable: true,
  get: function get() {
    return _SceneLayouts.SCENE_ASPECT_RATIO;
  }
});
Object.defineProperty(exports, "SCENE_WIDTH", {
  enumerable: true,
  get: function get() {
    return _SceneLayouts.SCENE_WIDTH;
  }
});
exports.ScaledSceneRenderer = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SceneLayouts = require("../../constants/SceneLayouts");
/**
 * Scales down the scene based on the page width while maintaining the aspect ratio.
 *
 * @param children
 * @param pageWidth
 * @param ratio
 * @returns {*}
 * @constructor
 */
var ScaledSceneRenderer = exports.ScaledSceneRenderer = function ScaledSceneRenderer(_ref) {
  var children = _ref.children,
    pageWidth = _ref.pageWidth,
    ratio = _ref.ratio;
  var width = pageWidth / ratio;
  var height = width / _SceneLayouts.SCENE_ASPECT_RATIO;
  var scale = width / _SceneLayouts.SCENE_WIDTH;
  return _react["default"].createElement("div", {
    id: "scaledStageContainer",
    style: {
      width: width,
      height: height
    }
  }, _react["default"].createElement("div", {
    style: {
      transform: "scale(".concat(scale, ")"),
      transformOrigin: 'left top'
    }
  }, children));
};
ScaledSceneRenderer.propTypes = {
  children: _propTypes["default"].elementType,
  // SceneRenderer component
  pageWidth: _propTypes["default"].number.isRequired,
  ratio: _propTypes["default"].number.isRequired
};